import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from "@angular/core";
import { CoreConfig } from "@obg/ngx.core";

@Component({
	selector: "obg-error-layout",
	templateUrl: "./error-layout.component.html",
	styleUrls: ["./error-layout.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	providers: [CoreConfig],
})
export class ErrorLayoutComponent {
	@HostBinding("class.obg-error-layout") hostCssClass = true;

	showHeader = false;

	constructor(coreConfig: CoreConfig) {
		this.showHeader = !coreConfig.isB2b;
	}
}
